import { forcePersonaInteractionRoute, updateShowRoute } from "features/journey-map/reducer/CJMActions";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getInteractionSelector } from "redux/memoizedSelectors";
import CustomTooltip from "shared/components/CustomTooltip";
import { Switch } from "shared/ui-basics";
import styled from "styled-components";
import { isCurrentInteractionInRoute } from "utils/helpers";

function MainRoute({ interaction, setInteraction, stageId, mode, calculatedRouteAttrib, forcedRouteAttrib }) {
	const { t } = useTranslation();
	const { cjmIdStr, personaIdStr } = useLocation().search.getAllMapsParams();

	const stagesInteractions = useSelector(getInteractionSelector(personaIdStr, stageId));
	const subscriptionPlan = useSelector((state) => state.auth?.userInfo?.UserSubscriptionPlanName);

	const isEnterprise = subscriptionPlan?.toLowerCase() === "enterprise";
	const isSharedEnterprise = subscriptionPlan?.toLowerCase() === "sharedenterprise";

	const { mainRoute, alternativeRoute } = interaction || {};
	const isMainOrAlternativeRoute = isCurrentInteractionInRoute(interaction, stagesInteractions, calculatedRouteAttrib, forcedRouteAttrib);

	const switches = {
		forcedMainRoute: {
            tooltip: "MAIN_ROUTE_DISABLE_WARNING",
            isTooltipDisabled: !isMainOrAlternativeRoute,
			disabled: mode.IsViewer() || (mainRoute && isMainOrAlternativeRoute),
			checked: isMainOrAlternativeRoute,
			systemCalculatedRoute: mainRoute,
		},
		forcedAlternativeRoute: {
            tooltip: "ALTERNATIVE_ROUTE_DISABLE_WARNING",
            isTooltipDisabled: !isMainOrAlternativeRoute,
			disabled: mode.IsViewer() || (alternativeRoute && isMainOrAlternativeRoute),
			checked: isMainOrAlternativeRoute,
			systemCalculatedRoute: alternativeRoute,
		},
	};
	if (!isEnterprise && !isSharedEnterprise) return null;

	const forceCustomerRoutes = ({ personaInteractionId, value }) => {
		let isMain = false;
		if (forcedRouteAttrib === "forcedMainRoute") {
			isMain = true;
		}
		forcePersonaInteractionRoute({ personaInteractionId, stageId, newValue: value, isMain: isMain, cjmIdStr, personaIdStr });
		if (value) {
			updateShowRoute({ cjmIdStr, showRoute: true, isMain: isMain });
		}
	};
	const handleSwitchRoute = (id) => {
		forceCustomerRoutes({ personaInteractionId: interaction?.id, value: !switches[forcedRouteAttrib].checked, type: id });
		setInteraction && setInteraction((prev) => ({ ...prev, [id]: !switches[forcedRouteAttrib].checked }));
	};

	return (
		<RoutesWrapper>
			<CustomTooltip text={t(switches[forcedRouteAttrib].tooltip)} placement={"bottom"} disabled={switches[forcedRouteAttrib]?.isTooltipDisabled}>
				<Switch checked={switches[forcedRouteAttrib].checked} onChange={() => handleSwitchRoute(forcedRouteAttrib)} disabled={switches[forcedRouteAttrib].disabled} />
			</CustomTooltip>
		</RoutesWrapper>
	);
}

MainRoute.displayName = "MainRoute_EditInteraction";
MainRoute.propTypes = {
	interaction: PropTypes.object,
	updateFunction: PropTypes.func,
};
export const RoutesWrapper = styled.div`
	display: flex;
	align-items: center;
	min-height: 40px;
`;
export default MainRoute;
